define([
    "jquery",
    "underscore",
    "marionette",
    "views/withdrawal/common_view",
    "forms/withdrawal/local_bankwire_stic_form"
], function($, _, Marionette, CommonView, BankwireSticpayForm) {
    return CommonView.extend({
        ui: _.extend(CommonView.prototype.ui, {
            'signature': '#signature',
            'signatureName': '#signature_name',
            'bankInfoContainer': '#bank_info_container',
            'bankInfo': '#bank_info',
            'bankName': '#bank_name',
            'bankAccount': '#bank_account',
            'swiftCode': '#swift_code',
            'bankAccountHolder': '#bank_account_holder',
            'bankAddress': '#bank_address',
            'bankCode': '#bank_code',
        }),

        events: _.extend(CommonView.prototype.events, {
            'change @ui.bankCode': 'updateBankName',
            'change @ui.bankInfo': 'updateBankDetails',
            'change @ui.accountNoSelect': function(e){
                this.updateFinancial();
                this.requestBankHistories();
            }
        }),

        initialize: function(){
            this.bindUIElements();
            this.delegateEvents();
            this.updateFinancial();
            this.form = new BankwireSticpayForm();

            if(this.ui.bankCode.val() !== undefined){
                this.updateBankName()
            }

            this.updateBankDetails();
        },

        updateBankName:function(){
            this.ui.bankName.val($("#bank_code option:selected").html());
        },

        updateBankDetails: function(e){
            if(e) e.preventDefault();

            var bankDetails = window.banks_list[this.ui.bankInfo.val()];

            console.log(bankDetails);

            if(bankDetails){
                this.ui.bankCode.val(bankDetails.bank_code);
                this.ui.bankName.val(bankDetails.bank_name);
                this.ui.bankAccount.val(bankDetails.bank_account);
                this.ui.bankAccountHolder.val(bankDetails.bank_account_holder);
            }else{
                this.ui.bankCode.val('');
                this.ui.bankName.val('');
                this.ui.bankAccount.val('');
                this.ui.bankAccountHolder.val('');
            }
        },

        requestBankHistories: function() {
            const currentPageUrl = window.location.href;
            const payMethod = currentPageUrl.substring(currentPageUrl.lastIndexOf('/') + 1) + '_stic';
            const mt4AccountNo = this.ui.accountNoSelect.val();

            const that = this;
            const requestUrl = '/rest_withdrawal/bank_histories'
            $.ajax({
                url: requestUrl,
                data: { mt4_account_no: mt4AccountNo, pay_method: payMethod },
                success: function(data) {
                    that.renderBankInfo(that, data);
                }
            })
        },

        renderBankInfo: function(that, data) {
            const bankHistories = data.bankHistories;
            const latestBankHistory = data.latestBankHistory;

            if(Object.keys(bankHistories).length === 0) {
                that.ui.bankInfoContainer.css('display', 'none');
                window.banks_list = [];
                that.updateBankDetails()
                return;
            }

            that.ui.bankInfoContainer.css('display', 'block');
            that.ui.bankInfo.find('option').remove()
            that.ui.bankInfo.append('<option>New Bank</option>');
            for(const key in bankHistories) {
                if(_.isEqual(bankHistories[key], latestBankHistory)) {
                    that.ui.bankInfo.append(`<option value="${key}" selected>${key}</option>`)
                    continue;
                }
                that.ui.bankInfo.append(`<option value="${key}">${key}</option>`)
            }

            window.banks_list = bankHistories;
            that.updateBankDetails()
        }
    });
});
